PJQ.views.punchlists.PunchlistTemplateCreatorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'modal-create-template'),
        width: '30%'
    },
    events: {
        'click .btn-save' : 'save'
    },
    beforeModalCreated: function () {
        this.model = new PJQ.models.punchlists.Template({
            projectId: this.options.project.id
        });

        this.options.project.fetchPunchlistTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates,
            punchlists: this.collection
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-punchlist'),
                isMultiple: true,
                noneSelectedText: 'Select Punchlist #',
                onChange: _.bind(function (value) {

                }, this)
            });

            new PJQ.inputs.AutocompleteInput({
                el: this.$('.input-template-name'),
                source: _.map(this.templates.models, function (template) {
                    return template.get('name')
                })
            });
        }
    },
    save: function () {
        let $name = this.$('.input-template-name'),
            name = $name.val();
        if (_.size(name.trim()) === 0) {
            PJQ.helpers.inputHelpers.setInputError($name);
            return;
        }
        else {
            PJQ.helpers.inputHelpers.setInputError($name, true);
        }

        let existingTemplate = this.templates.findWhere({name: name}),
            fnSave = _.bind(function () {
                this.model.set({
                    name: name,
                    copyComments: this.$('.input-copy-comments').prop('checked'),
                    copyAssignee: this.$('.input-copy-assignee').prop('checked'),
                    copyGroups: this.$('.input-copy-trades').prop('checked')
                });
                this.model.save(null, {
                    success: _.bind(function () {
                        this.removeModal();
                        PJQ.notifications.notify.successNotify({
                            message: 'Punchlist Template Created'
                        });
                    }, this)
                });
            }, this);
        if (existingTemplate != null) {
            new PJQ.views.modals.YesNo({
                header: "Overwrite Template",
                body: "A template already exists with this name.  Would you like to overwrite it?",
                onYes: _.bind(function () {
                    this.model.set('templateId', existingTemplate.id);
                    fnSave();
                }, this)
            });
        }
        else {
            fnSave();
        }
    }
});

PJQ.views.punchlists.ImportTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'modal-import-template'),
        maxWidth: 500,
        onImport: null
    },
    events: {
        'click .btn-import': 'save'
    },
    beforeModalCreated: function () {
        this.options.project.fetchPunchlistTemplates(_.bind(function (tmp) {
            this.templates = tmp;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            templates: this.templates
        };
    },
    afterRender: function () {
        if (this.templates != null && this.templates.isFetched) {
            this.templatePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-template'),
                onChange: _.bind(function (value) {
                    this.selectedTemplate = this.templates.get(value);
                }, this),
                isIntChoices: true,
                noneSelectedText: 'Select Template'
            });

        }
    },
    save: function () {
        let isValid = true;
        if (this.selectedTemplate == null) {
            this.templatePicker.showError();
            isValid = false;
        }
        else {
            this.templatePicker.hideError();
        }


        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'punchlists'
                },
                {
                    endpoint: 'import',
                    value: this.selectedTemplate.id
                }
            ], [
                {
                    parameter: 'importComments',
                    value: this.$('.input-import-comments').prop('checked')
                },
                {
                    parameter: 'importAssignee',
                    value: this.$('.input-import-assignee').prop('checked')
                },
                {
                    parameter: 'importGroups',
                    value: this.$('.input-import-trades').prop('checked')
                },
                {
                    parameter: 'importAttachments',
                    value: this.$('.input-import-attachments').prop('checked')
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(_.bind(function (response) {
            if (typeof this.options.onImport === 'function') {
                let result = new PJQ.collections.punchlists.PunchlistItems(response);
                result.isFetched = true;
                this.options.onImport(result);
            }
            this.removeModal();
            PJQ.notifications.notify.successNotify({
                message: 'Punchlist Template Imported'
            });
        }, this));
    }
});

PJQ.views.punchlists.EditTemplateModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PUNCHLISTS, 'Modal-Edit-Template'),
        maxWidth: '90%',
        fitHeight: true,
        onClose: null
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-delete': 'deleteTemplate'
    },
    beforeModalCreated: function () {
        this.listenTo(this.model, 'fetch', this.render);
        this.model.fetch();
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        if (this.model.isFetched) {

            new PJQ.inputs.TextEditorInput({
                el: this.$('.edit-template-name'),
                label: 'Name',
                value: this.model.get('name'),
                onSave: _.bind(function (value) {
                    this.model.patch({
                        name: value
                    });
                }, this)
            });

            new PJQ.views.punchlists.PunchlistView({
                el: this.$('.manage-template'),
                model: this.model,
                collection: this.model.punchlistItems
            });
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose(this.model);
        }
    },
    deleteTemplate: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this template?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});


PJQ.views.punchlists.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.punchlists.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.punchlists.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.punchlists.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});
